// AUTO-GENERATED by scripts/generate-storefront-codes.ts — do not edit manually
// Re-run: pnpm codegen:storefront-codes

/** The Storefront API `CountryCode` enum. */
export const STOREFRONT_COUNTRY_CODES = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ",
] as const;

/**
 * The Storefront API `LanguageCode` enum. The Admin API `LanguageCode` is a
 * different enum; do not use it here.
 */
export const STOREFRONT_LANGUAGE_CODES = [
  "AF",
  "AK",
  "AM",
  "AR",
  "AS",
  "AZ",
  "BE",
  "BG",
  "BM",
  "BN",
  "BO",
  "BR",
  "BS",
  "CA",
  "CE",
  "CKB",
  "CS",
  "CY",
  "DA",
  "DE",
  "DZ",
  "EE",
  "EL",
  "EN",
  "EO",
  "ES",
  "ET",
  "EU",
  "FA",
  "FF",
  "FI",
  "FIL",
  "FO",
  "FR",
  "FY",
  "GA",
  "GD",
  "GL",
  "GU",
  "GV",
  "HA",
  "HE",
  "HI",
  "HR",
  "HU",
  "HY",
  "IA",
  "ID",
  "IG",
  "II",
  "IS",
  "IT",
  "JA",
  "JV",
  "KA",
  "KI",
  "KK",
  "KL",
  "KM",
  "KN",
  "KO",
  "KS",
  "KU",
  "KW",
  "KY",
  "LB",
  "LG",
  "LN",
  "LO",
  "LT",
  "LU",
  "LV",
  "MG",
  "MI",
  "MK",
  "ML",
  "MN",
  "MR",
  "MS",
  "MT",
  "MY",
  "NB",
  "ND",
  "NE",
  "NL",
  "NN",
  "NO",
  "OM",
  "OR",
  "OS",
  "PA",
  "PL",
  "PS",
  "PT_BR",
  "PT_PT",
  "QU",
  "RM",
  "RN",
  "RO",
  "RU",
  "RW",
  "SA",
  "SC",
  "SD",
  "SE",
  "SG",
  "SI",
  "SK",
  "SL",
  "SN",
  "SO",
  "SQ",
  "SR",
  "SU",
  "SV",
  "SW",
  "TA",
  "TE",
  "TG",
  "TH",
  "TI",
  "TK",
  "TO",
  "TR",
  "TT",
  "UG",
  "UK",
  "UR",
  "UZ",
  "VI",
  "WO",
  "XH",
  "YI",
  "YO",
  "ZH_CN",
  "ZH_TW",
  "ZU",
  "ZH",
  "PT",
  "CU",
  "VO",
  "LA",
  "SH",
  "MO",
] as const;
